import { createStore } from 'vuex'
//import api from 'api'
import api from '@/api'



export default createStore({
    state: {
        user: {},
        animation: {},
        timer_date: {
            date: '2022-06-22T17:51:16+00:00'
        },
        loaded: false,
        loadedUser: false,
        preloaded: false,
        editor: false,
        root: false,
        access: false,
        mobile: false,
        lang: 'En',
        multilang: true,
        navGeneral: { En: 'Главная', Ru: 'General' },
        text: {},
        blocks: {},
        sections: {},
        deadlines: {},
        motifications: {},
        errors: { En: 'Error occured. Please try again later!', Ru: 'Произошла ошибка. Пожалуйста, повторите позже!', code: '', activ: false }

    },
    getters: {
        Animation: state => {
            return state.animation
        },
        Sections: state => {
            return state.sections
        },
        Loaded: state => {
            return state.loaded
        },
        LoadedUser: state => {
            return state.loadedUser
        },
        Deadlines: state => {
            return state.deadlines
        },
        TimerDate: state => {
            return state.timer_date
        },
        Preloaded: state => {
            return state.preloaded
        },
        User: state => {
            return state.user
        },
        Editor: state => {
            return state.editor
        },
        Errors: state => {
            return state.errors
        },
        Lang: state => {
            return state.lang
        },
        MultiLang: state => {
            return state.multilang
        },
        NavGeneral: state => {
            return state.navGeneral[state.lang]
        },
        GetAccess: state => {
            return state.access
        },
        GetText: state => {
            return state.text
        },
        GetMobile: state => {
            return state.mobile
        },
        GetEditor: state => {
            return state.editor
        },
        GetRoot: state => {
            return state.root
        },
        GetBlock: state => {
            return state.blocks
        },
        GetNOtifications: state => {
            return state.notifications
        }

    },
    mutations: {
        SET_ANIMATION: (state, payload) => {
            state.animation = payload
        },
        SET_ACCESS: (state) => {

            if (localStorage.getItem('access_token') != null) {
                state.access = localStorage.getItem('access_token').length > 200 ? true : false
            }

        },
        SET_TIMER_DATE: (state, payload) => {
            state.timer_date.date = payload
        },

        SET_USER: (state, payload) => {
            var ln = ''
            if (payload.lang) {
                ln = payload.lang == 'En' ? 'Ru' : 'En'
            } else {
                ln = navigator.language == 'ru-RU' ? 'Ru' : 'En'
            }
            console.log(ln)
            payload.lang = ln
            localStorage.localization = ln
            state.user = payload


            console.log()
        },

        SET_ACCESS_DIR: (state, payload) => {
            state.access = payload

        },
        SET_Text: (state, payload) => {
            state.text = payload
        },
        SET_Errors: (state, code) => {
            state.errors.code = code[0]
            state.errors.activ = code[1]
        },
        SET_Blocks: (state, payload) => {
            state.blocks = payload
        },
        SET_Sections: (state, payload) => {
            state.sections = payload
        },
        SET_Notifications: (state, payload) => {
            state.notifications = payload
        },
        SET_Deadlines: (state, payload) => {
            state.deadlines = payload
        },
        SET_Loaded: (state, payload) => {
            state.loaded = payload
        },
        SET_Loaded_user: (state, payload) => {
            state.loadedUser = payload
        },
        SET_Preloaded: (state, payload) => {
            state.preloaded = payload
        },
        SET_Lang: (state, payload) => {
            state.lang = payload
        },
        CHANGE_Lang: (state) => {
            state.lang = state.lang == 'Ru' ? 'En' : 'Ru'
            localStorage.localization = state.lang
        },
        SET_Mobile: (state) => {
            state.mobile = window.innerWidth > 1000 ? true : false
        },
        CHANGE_Editor: (state) => {
            state.editor = state.editor ? false : true;

        }
    },
    actions: {
        LOAD_All: (context) => {
            context.dispatch('LOAD_BLOCKS')
            context.commit('SET_ACCESS')
            if (localStorage.getItem('access_token') != null) {
                context.dispatch('LOAD_ME')
            }

            //context.dispatch('LOAD_LANG')
        },
        LOAD_ME: (context) => {
            api({
                    method: 'post',
                    url: '/api/auth/me'
                })
                .then(function(response) {
                    context.commit('SET_USER', response.data)
                    context.commit('SET_ACCESS_DIR', true)
                }).catch(error => {
                    error
                    context.commit('SET_ACCESS_DIR', false)
                });
        },
        LOAD_LANG: (context) => {
            context.commit('SET_Preloaded', false)
            context.commit('SET_Mobile')
            api({
                    method: 'post',
                    url: '/api/text'
                })
                .then(function(response) {
                    var lang = new Object();
                    for (const key in response.data) {
                        let arr = Object.values(response.data[key])
                        let temp = {
                            [arr[1]]: {
                                Ru: arr[3],
                                En: arr[2]
                            }
                        }
                        lang[arr[0]] = {...lang[arr[0]], ...temp }

                    }
                    context.commit('SET_Text', lang)
                    context.commit('SET_Loaded', true)
                    context.commit('SET_Preloaded', true)
                    context.commit('SET_TIMER_DATE', lang.deadlines.timer_date.En)
                });
        },
        LOAD_SECTIONS: (context) => {

            api({
                method: 'post',
                url: '/api/sections'
            }).then(function(response) {
                var section = []
                response.data.forEach(element => {
                    section.push({ id: element.id, En: element.ru, Ru: element.en })
                });
                context.commit('SET_Sections', section)
            })
        },
        CHECK_ACCESS: (context) => {
            if (localStorage.getItem('access_token') != null) {
                api.post('api/auth/refresh').then(res => {
                    if (res.status === 200) {
                        context.commit('SET_ACCESS', true)
                    } else {
                        context.commit('SET_ACCESS', false)
                    }
                }).catch(error => {
                    context.commit('SET_ACCESS', error.response.status)
                })
            }



        },
        LOAD_ANIMATIONS: (context) => {
            api({
                    method: 'post',
                    url: '/api/animations'
                })
                .then(function(response) {
                    let set = {}
                    for (const key in response.data) {
                        let arr = Object.values(response.data[key])
                        set = Object.assign(set, {
                            [arr[0]]: JSON.parse(arr[1])
                        })
                    }
                    context.commit('SET_ANIMATION', set)
                        //console.log(response.data)
                        //var not = new Object();
                        //for (const key in response.data) {
                        //    let arr = Object.values(response.data[key])
                        //    let temp = {
                        //        [arr[1]]: {
                        //            Ru: arr[3],
                        //            En: arr[2]
                        //        }
                        //    }
                        //    not[arr[0]] = {...not[arr[0]], ...temp }
                        //}
                        ////console.log(not)
                        //context.commit('SET_Notifications', not)
                        //    // context.commit('SET_Loaded', true)
                        //    // context.commit('SET_Preloaded', true)
                });
        },

        LOAD_NOTIFICATION: (context) => {
            api({
                    method: 'post',
                    url: '/api/notifications'
                })
                .then(function(response) {
                    var not = new Object();

                    for (const key in response.data) {
                        let arr = Object.values(response.data[key])
                        let temp = {
                            [arr[1]]: {
                                Ru: arr[3],
                                En: arr[2]
                            }
                        }

                        not[arr[0]] = {...not[arr[0]], ...temp }

                    }
                    //console.log(not)
                    context.commit('SET_Notifications', not)
                        // context.commit('SET_Loaded', true)
                        // context.commit('SET_Preloaded', true)
                });
        },
        LOAD_DEADLINES: (context) => {
            const date = new Date();

            // get the year, month, and day from the date object
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')

            // combine the year, month, and day into a single string with the desired format
            const formattedDate = `${year}-${month}-${day}`
            const curDate = new Date(formattedDate)
            api({
                    method: 'post',
                    url: '/api/deadlines'
                })
                .then(function(response) {
                    var deadlines = []
                    var finished = true
                    var timer = false
                    response.data.forEach(element => {
                        let deadlineDate = new Date(element.date)
                        if (curDate >= deadlineDate) {
                            //console.log(formattedDate + '>=' + element.date)
                        } else {
                            timer = finished ? true : false
                            finished = false
                                //console.log(formattedDate + '<' + element.date)
                        }
                        if (timer) {
                            context.commit('SET_TIMER_DATE', element.date + 'T23:59:00+07:00')
                        }
                        deadlines.push({
                            id: element.id,
                            date: element.date,
                            timer: timer,
                            finished: finished,
                            title: {
                                En: element.title_ru,
                                Ru: element.title_en
                            },
                            annatations: {
                                En: element.anatations_ru,
                                Ru: element.anatations_en
                            },
                            status: {
                                En: element.status_ru,
                                Ru: element.status_en
                            }
                        })
                    });

                    //console.log(deadlines)
                    context.commit('SET_Deadlines', deadlines)
                        // context.commit('SET_Loaded', true)
                        // context.commit('SET_Preloaded', true)
                });
        },
        LOAD_BLOCKS: (context) => {
            context.commit('SET_Preloaded', false)
            context.commit('SET_Mobile')
            api({
                    method: 'post',
                    url: '/api/blocks'
                })
                .then(function(response) {

                    var section = new Object();
                    for (const key in response.data) {
                        let arr = Object.values(response.data[key])
                        section[arr[0]] = arr[1]
                    }
                    context.commit('SET_Blocks', section)
                    context.dispatch('LOAD_LANG')
                    context.dispatch('LOAD_NOTIFICATION')
                    context.dispatch('LOAD_DEADLINES')
                    context.dispatch('LOAD_SECTIONS')
                    context.dispatch('LOAD_ANIMATIONS')
                }).catch(function(error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        context.commit('SET_Errors', [error.response.status, true])

                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        //context.commit('SET_Errors', [error.response.status, true])
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        //context.commit('SET_Errors', [error.response.status, true])
                    }

                });

        },

    },
    modules: {}
})